import { useState, useEffect, useContext, Fragment, createContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import {
    Alert, Collapse, Box, TextField, IconButton, Button, AppBar, Toolbar, Typography,
    FormControl, InputLabel, Select, MenuItem, Autocomplete, CircularProgress
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { FormContext } from "./ManageCommunications";
import { axiosFunction, clearSession } from '../../common';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

export const UserFormContext = createContext(null);

export const CommunicationForm = ({ own }) => {
    const navigate = useNavigate(null);

    const buttonRef = useRef();

    const { handleDialogClose, onSubmit, loaderText, formField, setFormField, alertStatus, alertOpen,
        alertMessage, setAlertStatus, setAlertOpen, setAlertMessage,
        lookUpsOptions, openForm, setOpenForm, setFormChangeFlag } = useContext(FormContext);


    const [loader, setLoader] = useState(true);
    const [loading, setLoading] = useState({ property: false, user: false });

    const [propertyOptions, setPropertyOptions] = useState(null);

    const actionFun = formField.action;

    const [userOptions, setUserOptions] = useState(null);
    const { register, control, handleSubmit, formState: { errors }, reset } = useForm();

    const fetchUserData = async (property_id, communicate_type) => {
        try {
            setLoading(prev => ({ ...prev, user: true }));
            setUserOptions([]);
            const params = { acct_type: 'IND' }
            if (property_id && communicate_type) {
                params.property_id = property_id;
                params.code = communicate_type;
            }
            const userData = await axiosFunction('auth/users', 'post', params);
            if (userData.status === 'success') {
                setUserOptions(userData.data);
            }
            setLoading(prev => ({ ...prev, user: false }));

        } catch (e) {
            setLoading(prev => ({ ...prev, user: false }));
            if (e?.response?.status === 401) {
                clearSession();
                navigate('/login');
            } else {
                console.log(e);
            }
        }

    }

    const loadProperties = async () => {
        try {
            setOpenForm(false);
            setLoading(prev => ({ ...prev, property: true }));
            var params = {};
            const propertyDataList = await axiosFunction('properties', 'get', params);
            if (propertyDataList.status === 'success') {
                setPropertyOptions(propertyDataList.data);
                setOpenForm(true);
            } else {
                setAlertOpen(true);
                setAlertStatus('error');
                setAlertMessage(propertyDataList.message);
            }
            setLoading(prev => ({ ...prev, property: false }));
        } catch (e) {
            setAlertOpen(true);
            setAlertStatus('error');
            setAlertMessage(e.message);
            setLoading(prev => ({ ...prev, property: false }));
            if (e?.response?.status === 401) {
                clearSession();
                navigate('/login');
            }
        }
    }


    useEffect(() => {
        setLoader(false);
        if (propertyOptions === null) loadProperties();
        if (actionFun === 'edit') {
            fetchUserData(formField.property_id, formField.type);
            reset(formField);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actionFun]);

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const getSelectedPropertyItem = (id) => {
        //console.log(propertyOptions);
        // eslint-disable-next-line
        const item = propertyOptions && propertyOptions.find((opt) => {
            if (opt && id && opt.id === id) {
                return opt;
            }
        });

        return item || null;
    }

    const getSelectedTypeItem = (type) => {
        // eslint-disable-next-line
        const item = lookUpsOptions.find((opt) => {
            if (opt && opt.code === type) {
                return opt;
            };
        })
        return item || null;
    }

    const getSelectedUserItem = (user_id) => {
        // eslint-disable-next-line
        const item = userOptions.find((opt) => {
            if (opt && opt.id === user_id) {
                return opt;
            };
        })
        return item || null;
    }

    return (
        <Fragment>
            <Box component="form" id="communicationForm" noValidate autoComplete="off" onChange={() => setFormChangeFlag(true)} onSubmit={handleSubmit(onSubmit)}>
                <AppBar sx={{ position: 'fixed' }} className="app-header-top">
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleDialogClose}
                            aria-label="close"
                            className="me-auto"
                        >
                            <CloseIcon />
                            <Typography sx={{ p: 2, flex: 1, width: 'auto' }} variant="h6" component="div" className="d-none d-lg-block">
                                {actionFun && actionFun[0].toUpperCase() + actionFun.slice(1)} {own === 'Y' ? 'My' : ''} Communication
                            </Typography>
                        </IconButton>

                        <Button type="button" className="themeholy-btn btn-secondary" style={{ marginRight: '10px' }} onClick={handleDialogClose}>
                            Cancel
                        </Button>
                        <Button type="submit" autoFocus className="themeholy-btn btn-normal" disabled={loader}>
                            {(loader) ? 'Saving...' : 'Save'}
                        </Button>
                    </Toolbar>
                </AppBar>
                <div className="container" style={{ paddingTop: '90px' }}>
                    <Collapse in={alertOpen}>
                        <Alert variant="filled" severity={alertStatus}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setAlertOpen(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                        >
                            {alertMessage}
                        </Alert>
                    </Collapse>

                    {openForm ?

                        <div className="row">
                            <div className="col-md-12 d-block d-lg-none">
                                <Typography sx={{ marginBottom: '15px' }} variant="h6" component="div">
                                    {actionFun && actionFun[0].toUpperCase() + actionFun.slice(1)} {own === 'Y' ? 'My' : ''} Communication
                                </Typography>
                            </div>
                            <div className="col-md-6">

                                <h5 className="mb-3" style={{ textAlign: 'left' }}>Communication Info:</h5>

                                <Controller
                                    id="property_id"
                                    name="property_id"
                                    control={control}
                                    rules={{
                                        required: "Property is required"
                                    }}
                                    render={({ field, fieldState }) => (
                                        <Autocomplete
                                            disablePortal
                                            options={propertyOptions ? propertyOptions : []}
                                            getOptionLabel={(option) => option ? (option.address1 ? option.address1 + ', ' : '') + (option.address2 ? option.address2 + ', ' : '') + option.suburb + ', ' + option.state + ' - ' + option.postcode : 'test'}
                                            sx={{ width: '100%' }}
                                            renderOption={(props, option) => (
                                                <Box component="li" {...props} key={"property_" + option.id}>
                                                    {option.address1 ? option.address1 : ''}, {option.address2 ? option.address2 + ', ' : ''}<br />{option.suburb}, {option.state} - {option.postcode}
                                                </Box>
                                            )}
                                            renderInput={(params) => <TextField {...params} label="Choose Property *" variant="outlined"
                                                error={!!fieldState.error}
                                                helperText={fieldState.error?.message}
                                                {...register(`property_id`, { required: 'Property is required' })}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {loading.property ? <CircularProgress color="inherit" size={20} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />}
                                            loadingText="Loading properties. Please wait..."
                                            noOptionsText={loading.property ? "Loading properties. Please wait..." : "Enter the existing property address to choose"}
                                            onChange={(_, data) => {
                                                field.onChange(data ? data.id : '');
                                                setFormChangeFlag(true);
                                                setFormField((prev) => ({ ...prev, property_id: data.id }));
                                                fetchUserData(data.id, formField.type);
                                            }}
                                            value={(formField.property_id && propertyOptions.length > 0) ? getSelectedPropertyItem(formField.property_id) : null}
                                            isOptionEqualToValue={(options, value) => options.valueOf === value.valueOf}
                                        />
                                    )}
                                />

                                <Controller
                                    name="type"
                                    control={control}
                                    rules={{
                                        required: "Communicate Type is required"
                                    }}
                                    render={({ field, fieldState }) => (
                                        <Autocomplete
                                            disablePortal
                                            id="type"
                                            options={lookUpsOptions}
                                            getOptionLabel={(option) => option.label ? option.label : ''}

                                            sx={{ width: '100%' }}
                                            renderOption={(props, option) => (
                                                <Box component="li" {...props} key={"type_" + option.id}>
                                                    {option.label}
                                                </Box>
                                            )}
                                            isOptionEqualToValue={(options, value) => options.valueOf === value.valueOf}
                                            renderInput={(params) => <TextField {...params}
                                                {...register(`type`, { required: 'Communicate Type is required' })}
                                                label="Choose Communicate Type *" variant="outlined"
                                                error={!!fieldState.error}
                                                helperText={fieldState.error?.message}

                                            />}
                                            onChange={(_, data) => {
                                                field.onChange(data ? data.id : '');
                                                setFormChangeFlag(true);
                                                setFormField((prev) => ({ ...prev, type: data ? data.code : '', type_name: data ? data.label : '' }));

                                                fetchUserData(formField.property_id, data.code);

                                            }}

                                            value={getSelectedTypeItem(formField.type)}
                                        />
                                    )}
                                />


                                <Controller
                                    id="individual_id"
                                    name="individual_id"
                                    control={control}
                                    rules={{
                                        required: "Communicate To is required"
                                    }}
                                    render={({ field, fieldState }) => (
                                        <Autocomplete
                                            disablePortal
                                            options={userOptions ? userOptions : []}
                                            getOptionLabel={(option) => option.label} sx={{ width: '100%' }}
                                            renderOption={(props, option) => (
                                                <Box component="li" {...props} key={"communicate_to_" + option.id}>
                                                    {option.label}
                                                </Box>
                                            )}
                                            renderInput={(params) => <TextField {...params} label={"Choose " + (formField.type_name ? formField.type_name : 'Communicate To ') + " *"} variant="outlined"
                                                error={!!fieldState.error}
                                                helperText={fieldState.error?.message}
                                                {...register(`individual_id`, { required: 'Communicate To is required' })}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {loading.user ? <CircularProgress color="inherit" size={20} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />}
                                            loadingText="Loading users. Please wait..."
                                            noOptionsText={loading.user ? "Loading users. Please wait..." : "Enter the existing user name to choose"}
                                            onChange={(_, data) => {
                                                setFormField((prev) => ({ ...prev, individual_id: data.id }));
                                                field.onChange(data ? data.id : '');
                                                setFormChangeFlag(true);
                                            }}
                                            value={formField.individual_id ? getSelectedUserItem(formField.individual_id) : null}
                                            isOptionEqualToValue={(options, value) => options.valueof === value.valueOf}
                                        />
                                    )}
                                />

                            </div>
                            <div className="col-md-6">
                                <h5 className="mb-3" style={{ textAlign: 'left' }}>Message Info:</h5>

                                <TextField
                                    name="message"
                                    multiline
                                    style={{ width: '100%' }}
                                    placeholder="Message *"

                                    {...register("message", { required: "Message is required" })}
                                    onChange={(e) => { setFormField((prev) => ({ ...prev, message: e.target.value })); setFormChangeFlag(true); }}

                                    defaultValue={formField.message ? formField.message : ''}
                                    error={errors.message ? true : false}
                                    helperText={errors.message?.message}
                                />

                                <FormControl fullWidth>
                                    <InputLabel id="status-select-label"> Choose Status </InputLabel>
                                    <Select
                                        labelId="status-select-label"
                                        id="status"
                                        name="status"
                                        error={errors.status ? true : false}
                                        value={formField.status}
                                        label="Select Status"
                                        {...register("status", { required: false })}
                                        onChange={(e) => { setFormField((prev) => ({ ...prev, status: e.target.value })); setFormChangeFlag(true); }}
                                        MenuProps={MenuProps}
                                    >
                                        <MenuItem value='Open'>Open</MenuItem>
                                        <MenuItem value='NoShow'>NoShow</MenuItem>
                                        <MenuItem value='Callback'>Callback</MenuItem>
                                        <MenuItem value='Closed'>Closed</MenuItem>
                                    </Select>
                                </FormControl>
                                {formField.status === 'Callback' &&
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <MobileDateTimePicker
                                            label="Callback Date & Time *"
                                            format="DD/MM/YYYY hh:mm A"
                                            name="communicate_at"
                                            minDate={dayjs(new Date())}
                                            maxDate={dayjs(new Date(new Date().setMonth(new Date().getMonth() + 12)))}
                                            defaultValue={formField.communicate_at ? dayjs(formField.communicate_at.split('-').reverse().join('/')) : dayjs(new Date())}
                                            onChange={(newValue) => {
                                                if (newValue === null) {
                                                    setFormField((prev) => ({ ...prev, communication_at: dayjs(new Date()) }));
                                                } else {
                                                    setFormField((prev) => ({ ...prev, communication_at: ((newValue !== null && new Date(newValue).toString() !== 'Invalid Date') ? dayjs(newValue).format('YYYY/MM/DD hh:mm A') : dayjs(new Date())) }));

                                                }
                                                setFormChangeFlag(true);
                                            }}
                                        />
                                    </LocalizationProvider>
                                }

                            </div>
                            <div className="col-md-12 mt-3 text-center">
                                <div className='row'>
                                    <div className='col-12 col-md-4 col-lg-6 col-sm-2 col-xl-6 col-xxl-6'></div>
                                    <div className='col-12 col-md-4 col-lg-3 col-sm-5 col-xl-3 col-xxl-3 text-end mb-3'>
                                        <Button type="button" className="themeholy-btn btn-secondary w-100" onClick={handleDialogClose}>Cancel</Button>

                                    </div>
                                    <div className='col-12 col-md-4 col-lg-3 col-sm-5 col-xl-3 col-xxl-3 text-end'>
                                        <Button type="submit" ref={buttonRef} autoFocus className="themeholy-btn btn-primary w-100" disabled={loaderText}>{(loaderText) ? 'Saving...' : 'Save'}</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : <div className="text-center p-5 m-5"><CircularProgress /><br />Form is loading. Please wait...</div>}

                    {/*)*/}

                </div>

            </Box>




        </Fragment >
    );


}